import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { useHistory } from 'react-router-dom';
import { convertNumber } from 'helpers/utils';

import { Icon } from 'components/Icon';
import { Loader } from 'components/Loader';

const ReservationCard = ({
  user,
  reservationId,
  reserveTerm,
  isApproved,
  instruments,
  comment,
  isCreatedByClient,
  isDeferrer,
  isNotViewed,
  hideInfo,
  reserveArchive,
  userOption,
}) => {
  const history = useHistory();

  const handleRedirect = () => {
    history.push(`/reservation/${reservationId}`);
  };

  const statusIcon = useMemo(() => {
    if (isCreatedByClient && isApproved === 0) {
      return { name: 'client-created', tooltipText: 'Создан клиентом' };
    }
    if (isDeferrer && isApproved === 0 && isNotViewed) {
      return { name: 'deferrer-reserve', tooltipText: 'Отложенный резерв' };
    }
    if (isApproved === 1) {
      return { name: 'check', tooltipText: 'Подтверждено' };
    } else if (isApproved === -1) {
      return { name: 'cancel', tooltipText: 'Отклонено' };
    } else if (isApproved === -2) {
      return { name: 'viber-red', tooltipText: 'Отклонено через Viber' };
    } else if (isApproved === 2) {
      return { name: 'timer', tooltipText: 'Просрочено' };
    }
    return null;
  }, [isApproved, isCreatedByClient, isDeferrer, isNotViewed]);

  const cardDate = moment(reserveTerm * 1000).format('DD.MM.YY');
  const cardTime = moment(reserveTerm * 1000).format('HH.mm');

  return (
    <div className={isNotViewed ? 'column-block-created-inside' : 'column-block'} onClick={handleRedirect}>
      {(!hideInfo || reserveArchive) && (
        <>
          {!userOption && <Loader type="small" color="skyblue" />}

          {userOption?.reserve_fio && (
            <div className="column-property">
              <div className="column-item">
                {user.isCreatedInside ? <Icon name="user" /> : <Icon name="userverify" />}
              </div>

              <div className="column-item">-</div>

              <div className="column-value">
                <b>{user.FIO}</b>
              </div>
            </div>
          )}

          {userOption?.reserve_phone_number && (
            <div className="column-property">
              <div className="column-item">
                <Icon name={user.individual ? 'phone' : 'hashtag'} />
              </div>

              <div className="column-item">-</div>

              {user.individual && (
                <div className="column-value">
                  <b>{convertNumber(user.PhMain)}</b>
                </div>
              )}

              {!user.individual && (
                <div className="column-value">
                  <b>{user.EDRPOU || user.INN}</b>
                </div>
              )}
            </div>
          )}

          {userOption?.reserve_date && (
            <div className="column-property">
              <div className="column-item">
                <Icon name="calendar" />
              </div>

              <div className="column-item">-</div>

              <div className="column-value">
                до <b>{cardTime}</b> - {cardDate}
              </div>
            </div>
          )}
        </>
      )}
      {(userOption?.reserve_instruments || hideInfo) && (
        <div className="column-property" style={{ alignItems: 'flex-start' }}>
          <div className="column-item">
            <Icon name="instrument" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value">
            {instruments &&
              instruments.map((instrument, i) => (
                <p key={i}>
                  <b>
                    {i + 1}. {instrument.title}
                  </b>{' '}
                  - {instrument.quantity} шт
                </p>
              ))}
          </div>
        </div>
      )}

      {comment && userOption?.reserve_commentary && (
        <div className="column-property" style={{ alignItems: 'flex-start' }}>
          <div className="column-item">
            <Icon name="comment-small" />
          </div>

          <div className="column-item">-</div>

          <div className="column-value">{comment}</div>
        </div>
      )}

      {statusIcon && (
        <div className="block-status circle-button">
          <Icon {...statusIcon} />
        </div>
      )}
    </div>
  );
};

ReservationCard.propTypes = {
  user: PropTypes.object,
  rentId: PropTypes.string,
  instruments: PropTypes.array,
  comment: PropTypes.string,
  isApproved: PropTypes.number,
  reservationId: PropTypes.string,
  reserveTerm: PropTypes.number,
  isCreatedByClient: PropTypes.bool,
  isNotViewed: PropTypes.bool,
  isDeferrer: PropTypes.bool,
  hideInfo: PropTypes.bool,
  reserveArchive: PropTypes.bool,
  userOption: PropTypes.any,
};

ReservationCard.defaultProps = {
  user: {},
  history: [],
  instruments: null,
  reserveTerm: Math.floor(Date.now() / 1000),
  isCreatedByClient: false,
  isNotViewed: false,
  isDeferrer: false,
  hideInfo: false,
  reserveArchive: false,
};

export { ReservationCard };
